import { showDialog } from "@widgets/CommonDialog";

/** 선택된 헤더가 자동처리(Y)면 알림 후 true(차단) 반환 */
export const fnCheckAutoProcess = async (
  gridRef: React.RefObject<any>,
  message = "자동 처리된 건입니다."
): Promise<boolean> => {
  const api = gridRef?.current?.api;
  if (!api) return false;

  const nodes = api.getSelectedNodes?.() || [];
  if (nodes.length === 0) return false;

  const row = nodes[0]?.data || {};
  const yn = String(row?.yn_autoprocess ?? "").toUpperCase();
  if (yn === "Y") {
    await showDialog("alter", message);
    return true;
  }
  return false;
};

export const fnCheckAutoProcessV2 = async (
  gridRef: React.RefObject<any>,
  message = "자동 처리된 건입니다."
): Promise<boolean> => {
  if (!gridRef) return false;

  const rows = gridRef.current?.getSelectedRows?.() || [];
  if (rows.length === 0) return false;

  const row = rows[0] || {};
  const yn = String(row?.yn_autoprocess ?? "").toUpperCase();
  if (yn === "Y") {
    await showDialog("alter", message);
    return true;
  }
  return false;
};
